import ApiService from "../ApiService";
import ApiServiceV2 from "../ApiServiceV2";

export default class VoucherService {
  static getDetail = async (id) => {
    const instance = ApiServiceV2();
    return (await instance).get(`/voucher/${id}`);
  };

  static getList = async (params) => {
    let num,
      cursor,
      tenant_id,
      category_id,
      type,
      keyword,
      deleted,
      property_id;

    if (params.num && params.num !== "") {
      num = `?num=${params.num}`;
    } else {
      num = `?`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.tenant_id && params.tenant_id !== "") {
      tenant_id = `&tenant_id=${params.tenant_id}`;
    }
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.deleted && params.deleted !== "") {
      deleted = `&deleted=${params.deleted}`;
    }

    const instance = ApiServiceV2();
    return (await instance).get(
      `/voucher${num}${cursor || ""}${tenant_id || ""}${category_id || ""}${
        type || ""
      }${keyword || ""}${deleted || ""}${property_id || ""}`
    );
  };

  static storeData = async (params) => {
    const instance = await ApiServiceV2();
    return instance.post(`/voucher`, params);
  };

  static putData = async (id, params) => {
    const instance = await ApiServiceV2();
    return instance.put(`/voucher/${id}`, params);
  };
  static check = async (params) => {
    const instance = await ApiServiceV2();
    return instance.post(`/voucher/check`, params);
  };

  static patchData = async (id, params) => {
    const instance = await ApiServiceV2();
    return instance.patch(`/voucher/${id}`, params);
  };

  static deleteData = async (id) => {
    const instance = await ApiServiceV2();
    return instance.delete(`/voucher/${id}`);
  };
}
